import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getPrice } from '../../../modules/cimb/selectors';
import Preloader from '../../../components/common/Preloader';

const mapStateToProps = state => ({
  price: getPrice(state)
});

const CashInPending = ({ price }) => (
  <div className="modal cash-in-pending">
    <div className="modal__header cash-in-pending__header">CASH OUT: £{price}</div>
    <Preloader text="Cashing out processing..." />
  </div>
);

CashInPending.propTypes = {
  price: PropTypes.string
};

export default connect(mapStateToProps)(CashInPending);
